import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto 40px;
  max-width: 775px;
`;

export const Content = styled.div`
  position: relative;
  padding-bottom: 56.25%;
`;

export const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
